import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
/**
 * `Service` The base service class, to provide generic methods or properties for
 * other inherited services to use.
 */
var Base = /*#__PURE__*/function () {
  /**
   * Create base service instance.
   *
   * @param sdk - the SDK instance
   */
  function Base(sdk) {
    _classCallCheck(this, Base);
    this.SDK = sdk;
  }

  /**
   * HttpService getter
   */
  return _createClass(Base, [{
    key: "HttpService",
    get: function get() {
      return this.SDK.HttpService;
    }

    /**
     * Config getter
     */
  }, {
    key: "Config",
    get: function get() {
      return this.SDK.Config;
    }

    /**
     * Cache getter
     */
  }, {
    key: "Cache",
    get: function get() {
      return this.SDK.Cache;
    }
  }]);
}();
export default Base;